<template>
  <div class="assinar-publico">
    <!-- Painel lateral -->
    <div class="painel-lateral">
      <div class="painel-conteudo">
        <div class="marca">
          <div class="marca-icone">
            <i class="fas fa-dumbbell"></i>
          </div>
          <h1>Diário de Treino</h1>
          <p class="marca-subtitulo">Assine e comece agora</p>
        </div>

        <div class="beneficios">
          <h6 class="beneficios-titulo">
            <i class="fas fa-star"></i>
            O que você leva
          </h6>
          <ul>
            <li>
              <i class="fas fa-users"></i>
              <div>
                <strong>Gestão de alunos</strong>
                <small>Cadastro, agenda e avaliação física completa</small>
              </div>
            </li>
            <li>
              <i class="fas fa-dumbbell"></i>
              <div>
                <strong>Elaborador de treinos</strong>
                <small>Monte planos e acompanhe a evolução</small>
              </div>
            </li>
            <li>
              <i class="fas fa-robot"></i>
              <div>
                <strong>Assistente de IA</strong>
                <small>Gere treinos automaticamente</small>
              </div>
            </li>
          </ul>
        </div>

        <div class="painel-rodape">
          <i class="fas fa-lock"></i>
          Pagamento seguro via Mercado Pago
        </div>
      </div>
    </div>

    <!-- Coluna do formulário -->
    <div class="coluna-form">
      <div class="form-wrapper">
        <!-- carregando plano -->
        <div v-if="loading" class="estado-box">
          <i class="fas fa-spinner fa-spin fa-3x text-primary"></i>
          <p class="mt-3 text-muted">Carregando...</p>
        </div>

        <!-- nenhum plano disponível -->
        <div v-else-if="!planos.length" class="estado-box">
          <div class="estado-icone bg-danger-soft">
            <i class="fas fa-exclamation-triangle text-danger"></i>
          </div>
          <h3 class="mt-3">Planos indisponíveis</h3>
          <p class="text-muted">Não foi possível carregar os planos. Tente novamente em instantes.</p>
        </div>

        <!-- seletor de planos (quando o plano não veio na URL) -->
        <template v-else-if="!plano && !emailExiste">
          <div class="form-header">
            <h2>Escolha seu plano</h2>
            <p class="text-muted small mb-0">Selecione um plano para continuar.</p>
          </div>

          <div v-if="patrocinador" class="convite-card">
            <div class="convite-avatar">{{ iniciais(patrocinador.nome) }}</div>
            <div class="convite-info">
              <small class="convite-label">Indicado por</small>
              <strong>{{ patrocinador.nome }}</strong>
            </div>
          </div>

          <div class="planos-lista">
            <button
              v-for="p in planos"
              :key="p.slug"
              type="button"
              class="plano-opcao"
              @click="escolherPlano(p)"
            >
              <div class="plano-opcao-info">
                <span class="plano-nome">{{ p.name }}</span>
                <span class="plano-meses">{{ p.months_commitment }} meses</span>
              </div>
              <div class="plano-opcao-valor">
                <strong>R$ {{ formatPrice(p.total_price) }}</strong>
                <small>{{ p.months_commitment }}x de R$ {{ formatPrice(p.monthly_price) }}</small>
              </div>
              <i class="fas fa-chevron-right seta"></i>
            </button>
          </div>
        </template>

        <!-- email já existe -->
        <div v-else-if="emailExiste" class="estado-box">
          <div class="estado-icone bg-warning-soft">
            <i class="fas fa-user-check text-warning"></i>
          </div>
          <h3 class="mt-3">Você já tem conta</h3>
          <p class="text-muted">
            Já existe uma conta com esse e-mail. Faça login e assine pela área do treinador.
          </p>
          <a href="/login" class="btn-continuar mt-2" style="text-decoration:none">
            <i class="fas fa-sign-in-alt"></i> Ir para o login
          </a>
        </div>

        <!-- formulário -->
        <template v-else>
          <div class="form-header">
            <h2>Crie sua conta</h2>
            <p class="text-muted small mb-0">É rápido — depois você segue pro pagamento.</p>
          </div>

          <!-- resumo do plano -->
          <div class="plano-card">
            <div class="plano-info">
              <span class="plano-nome">{{ plano.name }}</span>
              <span class="plano-meses">{{ plano.months_commitment }} meses</span>
            </div>
            <div class="plano-valor">
              <strong>R$ {{ formatPrice(plano.total_price) }}</strong>
              <small>em até {{ plano.months_commitment }}x de R$ {{ formatPrice(plano.monthly_price) }}</small>
            </div>
          </div>
          <button v-if="planos.length > 1" type="button" class="trocar-plano" @click="voltarSelecao">
            <i class="fas fa-chevron-left"></i> Trocar plano
          </button>

          <!-- patrocinador (se veio por link de afiliado) -->
          <div v-if="patrocinador" class="convite-card">
            <div class="convite-avatar">{{ iniciais(patrocinador.nome) }}</div>
            <div class="convite-info">
              <small class="convite-label">Indicado por</small>
              <strong>{{ patrocinador.nome }}</strong>
            </div>
          </div>

          <form @submit.prevent="enviar" class="form-cadastro">
            <div class="campo">
              <label><i class="fas fa-user"></i> Nome completo *</label>
              <input v-model="form.nome" type="text" required maxlength="150" placeholder="Seu nome" />
            </div>

            <div class="row-campos">
              <div class="campo">
                <label><i class="fas fa-envelope"></i> E-mail *</label>
                <input v-model="form.email" type="email" required maxlength="150" placeholder="seu@email.com" />
              </div>
              <div class="campo">
                <label><i class="fas fa-lock"></i> Senha *</label>
                <input v-model="form.senha" type="password" required minlength="6" maxlength="100" placeholder="mín. 6 caracteres" />
              </div>
            </div>

            <div class="row-campos">
              <div class="campo">
                <label><i class="fab fa-whatsapp"></i> Telefone</label>
                <input v-model="form.telefone" type="tel" maxlength="30" placeholder="(11) 99999-9999" />
              </div>
              <div class="campo">
                <label><i class="fas fa-id-card"></i> CPF</label>
                <input v-model="form.cpf" type="text" maxlength="20" placeholder="000.000.000-00" />
              </div>
            </div>

            <button type="submit" class="btn-continuar" :disabled="enviando">
              <i v-if="enviando" class="fas fa-spinner fa-spin"></i>
              <i v-else class="fas fa-arrow-right"></i>
              {{ enviando ? 'Gerando pagamento...' : 'Continuar para o pagamento' }}
            </button>

            <div v-if="erro" class="erro-envio">
              <i class="fas fa-exclamation-circle"></i> {{ erro }}
            </div>

            <p class="ja-tenho">
              Já tem conta? <a href="/login">Fazer login</a>
            </p>
          </form>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import subscriptionRepository from '@/services/api/subscriptionRepository'
import redeMarketingApi from '@/services/api/redeMarketingRepository'

const route = useRoute()
const planoSlug = route.query.plano
const ref_ = route.query.ref || null

const loading = ref(true)
const planos = ref([])
const plano = ref(null)
const patrocinador = ref(null)
const enviando = ref(false)
const erro = ref('')
const emailExiste = ref(false)

function escolherPlano(p) {
  plano.value = p
}

function voltarSelecao() {
  plano.value = null
  erro.value = ''
}

const form = reactive({
  nome: '',
  email: '',
  senha: '',
  telefone: '',
  cpf: '',
})

function formatPrice(v) {
  return Number(v || 0).toFixed(2).replace('.', ',')
}

function iniciais(nome) {
  if (!nome) return '?'
  const p = nome.trim().split(/\s+/)
  return (p.length === 1 ? p[0].substring(0, 2) : p[0][0] + p[p.length - 1][0]).toUpperCase()
}

onMounted(async () => {
  try {
    const resp = await subscriptionRepository.plans()
    planos.value = resp.data?.data || []
    // Se o plano veio na URL (landing), ja seleciona; senao mostra o seletor.
    if (planoSlug) {
      plano.value = planos.value.find((p) => p.slug === planoSlug) || null
    }
  } catch (e) {
    planos.value = []
  } finally {
    loading.value = false
  }

  // Valida o patrocinador (não bloqueia o pagamento se falhar)
  if (ref_) {
    try {
      const resp = await redeMarketingApi.BuscarPatrocinadorPublico(ref_)
      if (resp.data && resp.data.ativo) {
        patrocinador.value = resp.data
      }
    } catch (e) {
      patrocinador.value = null
    }
  }
})

async function enviar() {
  enviando.value = true
  erro.value = ''
  emailExiste.value = false
  try {
    const payload = {
      name: form.nome,
      email: form.email,
      password: form.senha,
      phone: form.telefone || null,
      cpf: form.cpf || null,
      plan_slug: plano.value.slug,
      ref: ref_,
    }
    const resp = await subscriptionRepository.publicCheckout(payload)
    const checkoutUrl = resp.data?.data?.checkout_url

    if (!checkoutUrl) {
      erro.value = 'Não foi possível gerar o link de pagamento. Tente novamente.'
      enviando.value = false
      return
    }

    // Se veio por indicação, registra o vínculo na rede (best-effort, não bloqueia).
    if (ref_) {
      try {
        await redeMarketingApi.CadastroPublico({
          codigoPatrocinador: ref_,
          nome: form.nome,
          email: form.email,
          cpf: form.cpf || null,
          telefone: form.telefone || null,
          dataNascimento: null,
        })
      } catch (e) {
        // vínculo na rede é secundário — segue pro pagamento
      }
    }

    window.location.href = checkoutUrl
  } catch (e) {
    if (e?.response?.status === 409) {
      emailExiste.value = true
    } else {
      erro.value = e?.response?.data?.message || 'Falha ao processar. Tente novamente.'
    }
    enviando.value = false
  }
}
</script>

<style scoped>
.assinar-publico {
  min-height: 100vh;
  background: #f8fafc;
  display: flex;
}

/* Painel lateral */
.painel-lateral {
  flex: 0 0 42%;
  background: linear-gradient(135deg, #2D3A7C 0%, #4f46e5 60%, #7c3aed 100%);
  color: #fff;
  padding: 40px 32px;
  position: relative;
  overflow: hidden;
}
.painel-lateral,
.painel-lateral h1,
.painel-lateral h6,
.painel-lateral strong,
.painel-lateral small,
.painel-lateral p,
.painel-lateral li,
.painel-lateral i {
  color: #fff !important;
}
.painel-lateral::before {
  content: '';
  position: absolute;
  top: -120px; right: -120px;
  width: 300px; height: 300px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 50%;
}
.painel-lateral::after {
  content: '';
  position: absolute;
  bottom: -100px; left: -100px;
  width: 260px; height: 260px;
  background: rgba(247, 148, 29, 0.15);
  border-radius: 50%;
}
.painel-conteudo {
  position: relative;
  z-index: 1;
  max-width: 400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: calc(100vh - 80px);
}
.marca { margin-bottom: 48px; }
.marca-icone {
  width: 64px; height: 64px;
  background: linear-gradient(135deg, #F7941D 0%, #f5a623 100%);
  border-radius: 18px;
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 1.8rem; color: #fff; margin-bottom: 16px;
  box-shadow: 0 8px 20px rgba(247, 148, 29, 0.4);
}
.marca h1 { font-size: 1.9rem; font-weight: 800; margin: 0; letter-spacing: -0.5px; }
.marca-subtitulo { opacity: 0.9; font-size: 0.95rem; margin-top: 4px; }
.beneficios-titulo {
  font-size: 0.78rem; text-transform: uppercase; letter-spacing: 0.6px;
  opacity: 0.85; margin-bottom: 18px; display: flex; align-items: center; gap: 6px;
}
.beneficios ul { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 18px; }
.beneficios li { display: flex; align-items: flex-start; gap: 14px; }
.beneficios li i {
  width: 36px; height: 36px; background: rgba(255, 255, 255, 0.15);
  border-radius: 10px; display: inline-flex; align-items: center; justify-content: center;
  font-size: 1rem; flex-shrink: 0;
}
.beneficios li strong { display: block; font-size: 0.95rem; line-height: 1.3; }
.beneficios li small { display: block; opacity: 0.85; font-size: 0.82rem; margin-top: 2px; line-height: 1.35; }
.painel-rodape {
  margin-top: auto; padding-top: 30px; font-size: 0.78rem; opacity: 0.85;
  display: flex; align-items: center; gap: 6px;
}

/* Coluna do formulário */
.coluna-form { flex: 1; display: flex; align-items: center; justify-content: center; padding: 40px 20px; }
.form-wrapper { width: 100%; max-width: 480px; }
.form-header { margin-bottom: 18px; }
.form-header h2 { font-size: 1.5rem; color: #1e293b; font-weight: 700; margin: 0 0 4px 0; }

/* Card do plano */
.plano-card {
  display: flex; align-items: center; justify-content: space-between;
  background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%);
  border: 1px solid #c7d2fe; border-radius: 12px; padding: 16px 18px; margin-bottom: 18px;
}
.plano-info { display: flex; flex-direction: column; }
.plano-nome { font-weight: 700; color: #1e293b; font-size: 1.05rem; }
.plano-meses { font-size: 0.8rem; color: #64748b; }
.plano-valor { text-align: right; }
.plano-valor strong { display: block; color: #2D3A7C; font-size: 1.2rem; }
.plano-valor small { color: #64748b; font-size: 0.75rem; }

/* Seletor de planos */
.planos-lista { display: flex; flex-direction: column; gap: 12px; }
.plano-opcao {
  display: flex; align-items: center; gap: 12px;
  width: 100%; text-align: left; cursor: pointer;
  background: #fff; border: 1.5px solid #e2e8f0; border-radius: 12px;
  padding: 14px 16px; transition: all 0.15s;
}
.plano-opcao:hover { border-color: #4f46e5; box-shadow: 0 6px 18px rgba(79, 70, 229, 0.12); transform: translateY(-1px); }
.plano-opcao-info { display: flex; flex-direction: column; flex: 1; }
.plano-opcao-valor { text-align: right; }
.plano-opcao-valor strong { display: block; color: #2D3A7C; font-size: 1.1rem; }
.plano-opcao-valor small { color: #64748b; font-size: 0.72rem; }
.plano-opcao .seta { color: #94a3b8; font-size: 0.85rem; }

.trocar-plano {
  background: none; border: none; color: #4f46e5; font-size: 0.82rem;
  font-weight: 600; cursor: pointer; padding: 0; margin: -8px 0 8px;
  display: inline-flex; align-items: center; gap: 4px;
}
.trocar-plano:hover { text-decoration: underline; }

/* Card do patrocinador */
.convite-card {
  display: flex; align-items: center; gap: 14px;
  background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px;
  padding: 12px 16px; margin-bottom: 18px;
}
.convite-avatar {
  width: 42px; height: 42px; border-radius: 50%;
  background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);
  color: #fff; font-weight: 700; font-size: 0.9rem;
  display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.convite-info { line-height: 1.2; }
.convite-label { color: #15803d; font-size: 0.72rem; text-transform: uppercase; letter-spacing: 0.3px; }
.convite-info strong { display: block; color: #14532d; font-size: 0.98rem; margin-top: 2px; }

/* Formulário */
.form-cadastro { display: flex; flex-direction: column; gap: 16px; }
.campo label {
  display: flex; align-items: center; gap: 6px; font-size: 0.82rem;
  font-weight: 600; color: #334155; margin-bottom: 6px;
}
.campo label i { color: #64748b; font-size: 0.82rem; }
.campo input {
  width: 100%; padding: 10px 14px; border: 1.5px solid #e2e8f0;
  border-radius: 10px; font-size: 0.95rem; background: #fff; transition: all 0.15s;
}
.campo input:focus { outline: none; border-color: #4f46e5; box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12); }
.row-campos { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
@media (max-width: 500px) { .row-campos { grid-template-columns: 1fr; } }

.btn-continuar {
  background: linear-gradient(135deg, #F7941D 0%, #e07c00 100%);
  color: #fff; border: none; padding: 14px; border-radius: 12px;
  font-weight: 700; font-size: 0.98rem; cursor: pointer;
  display: flex; align-items: center; justify-content: center; gap: 8px;
  transition: all 0.15s; box-shadow: 0 4px 14px rgba(247, 148, 29, 0.3);
}
.btn-continuar:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 8px 24px rgba(247, 148, 29, 0.4); }
.btn-continuar:disabled { opacity: 0.7; cursor: not-allowed; }

.erro-envio {
  background: #fef2f2; border: 1px solid #fecaca; color: #991b1b;
  padding: 10px 14px; border-radius: 8px; font-size: 0.88rem;
  display: flex; align-items: center; gap: 8px;
}
.ja-tenho { text-align: center; font-size: 0.85rem; color: #64748b; margin: 4px 0 0; }
.ja-tenho a { color: #4f46e5; font-weight: 600; }

/* Estados */
.estado-box { text-align: center; padding: 30px 10px; }
.estado-icone {
  width: 80px; height: 80px; border-radius: 50%;
  display: inline-flex; align-items: center; justify-content: center; font-size: 2.2rem;
}
.bg-danger-soft { background: #fee2e2; }
.bg-warning-soft { background: #fef3c7; }
.estado-box h3 { font-size: 1.4rem; color: #1e293b; font-weight: 700; }

/* Responsivo */
@media (max-width: 900px) {
  .assinar-publico { flex-direction: column; }
  .painel-lateral { flex: none; padding: 24px 20px 40px; }
  .painel-conteudo { min-height: auto; }
  .beneficios { margin-bottom: 10px; }
  .painel-rodape { margin-top: 20px; }
  .marca { margin-bottom: 24px; text-align: center; }
  .coluna-form { padding: 30px 16px; }
}
</style>
